import { Column } from "@/constants/pipeline";
import { RowContent } from "./RowContent";

type DashboardRowProps = {
  name: string;
  columns: Column[];
  sortBy?: string;
  highlightColor?: string;
  isClickable?: boolean;
  onNameClick?: (teamName: string) => void;
  children?: React.ReactNode;
};

export const DashboardRow = ({
  name,
  columns,
  sortBy,
  highlightColor,
  isClickable = false,
  onNameClick,
  children,
}: DashboardRowProps) => {
  const handleTeamClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onNameClick) {
      onNameClick(name);
    }
  };

  return (
    <tr className="border-b border-solid border-slate-200 transition-colors duration-200">
      <RowContent columns={columns} sortBy={sortBy} highlightColor={highlightColor}>
        {onNameClick ? (
          <span
            className={`cursor-pointer font-medium underline transition-opacity hover:opacity-70 ${
              isClickable ? "text-primary-600" : ""
            }`}
            onClick={handleTeamClick}
          >
            {name}
          </span>
        ) : (
          <span className="font-medium">{name}</span>
        )}
        {children}
      </RowContent>
    </tr>
  );
};
